// src/components/HeroCarousel.jsx

import { useEffect, useState } from "react";
import { Box, Container, Paper } from "@mui/material";

export default function HeroCarousel({
  images = [],
  interval = 2000,
  height = 380,
  maxWidth = 1200,
}) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    // אם רשימת התמונות השתנתה, חוזרים לתמונה הראשונה
    setIdx(0);
  }, [images]);

  useEffect(() => {
    // אין צורך להפעיל החלפה כשיש פחות משתי תמונות
    if (images.length < 2) {
      return;
    }

    const id = setInterval(() => {
      setIdx((prev) => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(id);
  }, [images.length, interval]);

  if (!images.length) {
    return null;
  }

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        width: "100%",
        px: 0,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          mx: "auto",
          width: "100%",
          maxWidth,

          // גובה מותאם לפי גודל המסך
          height: {
            xs: "auto",
            md: height,
          },

          aspectRatio: {
            xs: "13 / 5",
            md: "auto",
          },

          borderRadius: {
            xs: 2,
            md: 3,
          },

          overflow: "hidden",
          position: "relative",
          backgroundColor: "#ffffff",
        }}
      >
        {images.map((src, i) => {
          // const isClickable = i === 1; // להחזיר בעתיד
          const isClickable = false;

          return (
            <Box
              key={`${src}-${i}`}
              component="img"
              src={src} 
              alt={
                isClickable
                  ? "פתיחת קובץ המבצעים"
                  : `תמונת מבצע ${i + 1}`
              }
              draggable={false}
              onClick={() => {
                if (isClickable) {
                  window.open(
                    "/files/promotions.pdf",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }
              }}
              onKeyDown={(event) => {
                if (
                  isClickable &&
                  (event.key === "Enter" ||
                    event.key === " ")
                ) {
                  event.preventDefault();

                  window.open(
                    "/files/promotions.pdf",
                    "_blank",
                    "noopener,noreferrer"
                  );
                }
              }}
              role={isClickable ? "button" : undefined}
              tabIndex={isClickable ? 0 : -1}
              aria-label={
                isClickable
                  ? "פתיחת קובץ המבצעים בחלון חדש"
                  : undefined
              }
              sx={{
                position: "absolute",
                inset: 0,
                width: "100%",
                height: "100%",

                /*
                 * בטלפון מוצגת כל התמונה בלי חיתוך.
                 * במחשב התמונה ממלאת את כל הקרוסלה.
                 */
                objectFit: {
                  xs: "contain",
                  md: "cover",
                },

                objectPosition: "center",
                opacity: i === idx ? 1 : 0,
                transition: "opacity 600ms ease",
                display: "block",

                cursor: isClickable
                  ? "pointer"
                  : "default",

                "&:focus-visible": {
                  outline: "4px solid #D81B60",
                  outlineOffset: "-4px",
                },
              }}
            />
          );
        })}
      </Paper>
    </Container>
  );
}